import { render } from "./movimientos.vue?vue&type=template&id=48357f7f"
import script from "./movimientos.vue?vue&type=script&lang=js"
export * from "./movimientos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__